module.exports = __webpack_public_path__ + "img/ic_check.356aa68.jpg";